export default {
    NO_CHANGE: 'NO_CHANGE',
    ADD_APP: 'ADD_APP',
    REMOVE_APP: 'REMOVE_APP',
    DISABLE_APP: 'DISABLE_APP',
    ENABLE_APP_ADD: 'ENABLE_APP_ADD',
    ENABLE_APP_ALLOW: 'ENABLE_APP_ALLOW',
    ENABLE_APP_GROUP: 'ENABLE_APP_GROUP',
    CHANGE_DEFAULT: 'CHANGE_DEFAULT',
};
